import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Procesando from '../Generales/Procesando';

function ConfiguracionTurnos(props) {
    const [turnos, setTurnos] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoInicio, setNuevoInicio] = useState('');
    const [nuevoFin, setNuevoFin] = useState('');
    const [reiniciaComandaPorTurno, setReiniciaComandaPorTurno] = useState(false);
    const [cambiandoSwitch, setCambiandoSwitch] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        axios.defaults.headers.common["token"] = token;
        getDatos();
        getReinicioComanda();
    }, []);

    async function getReinicioComanda() {
        await axios.get(config.api_url + '/configuracion/turnos/reinicio-comanda/').then(resp => {
            if (resp.data.completado) {
                setReiniciaComandaPorTurno(!!resp.data.reinicia_comanda_por_turno);
            }
        }).catch(error => {
            // silencioso -- si falla, el switch queda apagado (comportamiento por defecto)
        });
    }

    async function onCambiarReinicioComanda(activo) {
        setCambiandoSwitch(true);
        await axios.post(config.api_url + '/configuracion/turnos/reinicio-comanda/', { activo }).then(resp => {
            setCambiandoSwitch(false);
            if (resp.data.completado) {
                setReiniciaComandaPorTurno(resp.data.reinicia_comanda_por_turno);
                toast.success(resp.data.mensaje);
            } else {
                toast.error(resp.data.mensaje);
            }
        }).catch(error => {
            setCambiandoSwitch(false);
            toast.error("Se ha generado un error al cambiar la preferencia!");
        });
    }

    async function getDatos() {
        setCargando(true);
        await axios.get(config.api_url + '/configuracion/turnos/').then(resp => {
            if (resp.data.completado) {
                setTurnos(resp.data.turnos);
            }
            setCargando(false);
        }).catch(error => {
            setCargando(false);
            toast.error("Se ha generado un error al traer los turnos!");
        });
    }

    function modificarCampo(indice, campo, valor) {
        const turnos_ = [...turnos];
        turnos_[indice][campo] = valor;
        setTurnos(turnos_);
    }

    async function guardarTurno(turno) {
        setCargando(true);
        await axios.put(config.api_url + '/configuracion/turnos/' + turno.id + '/', {
            nombre: turno.nombre,
            horaInicio: turno.hora_inicio,
            horaFin: turno.hora_fin,
        }).then(resp => {
            setCargando(false);
            if (resp.data.completado) {
                toast.success(resp.data.mensaje);
            } else {
                toast.error(resp.data.mensaje);
            }
        }).catch(error => {
            setCargando(false);
            toast.error("Se ha generado un error al guardar el turno!");
        });
    }

    async function eliminarTurno(turnoId) {
        setCargando(true);
        await axios.delete(config.api_url + '/configuracion/turnos/' + turnoId + '/').then(resp => {
            setCargando(false);
            if (resp.data.completado) {
                toast.success(resp.data.mensaje);
                getDatos();
            } else {
                toast.error(resp.data.mensaje);
            }
        }).catch(error => {
            setCargando(false);
            toast.error("Se ha generado un error al eliminar el turno!");
        });
    }

    async function crearTurno() {
        if (!nuevoNombre || !nuevoInicio || !nuevoFin) {
            toast.error("Complete nombre, hora inicio y hora fin.");
            return;
        }
        setCargando(true);
        await axios.post(config.api_url + '/configuracion/turnos/', {
            nombre: nuevoNombre,
            horaInicio: nuevoInicio,
            horaFin: nuevoFin,
        }).then(resp => {
            setCargando(false);
            if (resp.data.completado) {
                toast.success(resp.data.mensaje);
                setNuevoNombre('');
                setNuevoInicio('');
                setNuevoFin('');
                getDatos();
            } else {
                toast.error(resp.data.mensaje);
            }
        }).catch(error => {
            setCargando(false);
            toast.error("Se ha generado un error al crear el turno!");
        });
    }

    return (
        <div className="contenedorMantenedor">
            <ToastContainer />
            <Modal open={cargando} showCloseIcon={false} center>
                <Procesando />
            </Modal>
            <div className='card'>
                <div className='card-header'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <a href='/configuracion/home/'><i className="bi bi-arrow-left-short"></i>Regresar</a>
                        </div>
                        <div className='col-md-4 titulo-formulario'>
                            <label>Configuración de Turnos</label>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <p className='text-muted small'>
                                Acá configuras los turnos del negocio, que podés usar para
                                filtrar los reportes. Si además querés que el número de comanda
                                empiece en 1 en cada cambio de turno (en vez de una vez al día),
                                activa el switch de abajo. Si no configuras nada ni activas el
                                switch, el sistema sigue funcionando exactamente igual que hoy.
                            </p>
                            <div className='row p-2 mb-3 rounded' style={{ background: reiniciaComandaPorTurno ? '#e6f9ed' : '#f8f9fa', border: '1px solid ' + (reiniciaComandaPorTurno ? '#28a745' : '#dee2e6') }}>
                                <div className='col-8'>
                                    <label className='mb-0'><b>Reiniciar numeración de comandas por turno</b></label>
                                    <div className='small text-muted'>
                                        {reiniciaComandaPorTurno
                                            ? 'Activo — el número de comanda vuelve a 1 en cada cambio de turno.'
                                            : 'Desactivado — el número de comanda resetea una vez al día, como siempre.'}
                                    </div>
                                    {turnos.length === 0 &&
                                        <div className='small text-danger'>Necesitas al menos un turno configurado abajo para que esto tenga efecto.</div>
                                    }
                                </div>
                                <div className='col-4 d-flex align-items-center justify-content-end'>
                                    <div className='custom-control custom-switch'>
                                        <input
                                            type='checkbox'
                                            className='custom-control-input'
                                            id='reiniciaComandaSwitch'
                                            checked={reiniciaComandaPorTurno}
                                            disabled={cambiandoSwitch}
                                            onChange={(ev) => onCambiarReinicioComanda(ev.target.checked)}
                                        />
                                        <label className='custom-control-label' htmlFor='reiniciaComandaSwitch'></label>
                                    </div>
                                </div>
                            </div>
                            <div className='container'>
                                <table className="table table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th scope="col">Nombre</th>
                                            <th scope="col">Hora Inicio</th>
                                            <th scope="col">Hora Fin</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {turnos.map((turno, indice) =>
                                            <tr key={turno.id}>
                                                <td>
                                                    <input type="text" className="form-control" value={turno.nombre}
                                                        onChange={(ev) => modificarCampo(indice, 'nombre', ev.target.value)} />
                                                </td>
                                                <td>
                                                    <input type="time" className="form-control" value={turno.hora_inicio}
                                                        onChange={(ev) => modificarCampo(indice, 'hora_inicio', ev.target.value)} />
                                                </td>
                                                <td>
                                                    <input type="time" className="form-control" value={turno.hora_fin}
                                                        onChange={(ev) => modificarCampo(indice, 'hora_fin', ev.target.value)} />
                                                </td>
                                                <td>
                                                    <button className='btn btn-sm btn-primary' onClick={() => guardarTurno(turno)}>Guardar</button>
                                                    {' '}
                                                    <button className='btn btn-sm btn-danger' onClick={() => eliminarTurno(turno.id)}>Eliminar</button>
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" placeholder="Ej: Mañana"
                                                    value={nuevoNombre} onChange={(ev) => setNuevoNombre(ev.target.value)} />
                                            </td>
                                            <td>
                                                <input type="time" className="form-control"
                                                    value={nuevoInicio} onChange={(ev) => setNuevoInicio(ev.target.value)} />
                                            </td>
                                            <td>
                                                <input type="time" className="form-control"
                                                    value={nuevoFin} onChange={(ev) => setNuevoFin(ev.target.value)} />
                                            </td>
                                            <td>
                                                <button className='btn btn-sm btn-success' onClick={crearTurno}>Agregar</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfiguracionTurnos;
